import React from "react";

import HomeAvatai from "./avatai/HomeAvatai";
import HomePelex from "./pelex/HomePelex";
import {isInAvataiSite} from "./shared/Utils";

const Home = (props: {isDemo?:boolean}) => {

  if (isInAvataiSite())
    return (
      <HomeAvatai />
    );
  else
    return (
      <HomePelex />
    );
};

export default Home;
